<template>
  <v-overlay v-model="isLoading" id="loading">
    <v-progress-circular color="#e3ffe2" indeterminate size="64" />
  </v-overlay>
  <v-card>
    <v-tabs v-model="tab" bg-color="primary">
      <v-tab value="tab1">投稿管理</v-tab>
      <v-tab value="tab2">メール配信管理</v-tab>
      <v-tab value="tab3">LINE既読管理</v-tab>
    </v-tabs>

    <v-card-text>
      <v-window v-model="tab">
        <v-window-item value="tab1">
          <v-data-table
            :headers="postHeaders"
            :items="postList"
            v-model="selectedPosts"
            hide-default-footer
            dense
            show-select
          ></v-data-table>
          <v-row justify="end" class="pr-2 pl-2 pb-2"
            ><v-dialog v-model="deleteDialog" persistent width="auto">
              <template v-slot:activator="{ props }">
                <v-btn color="primary" class="mt-2 mr-2 mb-2" v-bind="props"
                  >選択投稿削除</v-btn
                >
              </template>
              <v-card>
                <v-card-text>本当に削除しますか？</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="green-darken-1"
                    variant="text"
                    @click="deleteDialog = false"
                  >
                    キャンセル
                  </v-btn>
                  <v-btn
                    color="green-darken-1"
                    variant="text"
                    @click="deletePosts()"
                  >
                    OK
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-btn color="primary" class="mt-2 mr-2 mb-2" @click="vacuum"
              >DB最適化</v-btn
            ></v-row
          >
        </v-window-item>

        <v-window-item value="tab2">
          <v-data-table
            :headers="mailHeaders"
            :items="mailList"
            v-model="selectedMails"
            hide-default-footer
            dense
            show-select
          ></v-data-table>
          <v-row justify="end" class="pr-2 pl-2 pb-2 mt-4">
            <v-text-field label="名前" v-model="addName"></v-text-field>
            <v-text-field
              label="メールアドレス"
              v-model="addMail"
              class="ml-2"
            ></v-text-field>
            <v-btn
              color="primary"
              class="mt-2 mr-2 mb-2 ml-2"
              @click="mailList_add"
              >メールアドレス追加</v-btn
            >
            <v-dialog v-model="deleteDialog2" persistent width="auto">
              <template v-slot:activator="{ props }">
                <v-btn color="primary" class="mt-2 mr-2 mb-2" v-bind="props"
                  >選択メールアドレス削除</v-btn
                >
              </template>
              <v-card>
                <v-card-text>本当に削除しますか？</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="green-darken-1"
                    variant="text"
                    @click="deleteDialog2 = false"
                  >
                    キャンセル
                  </v-btn>
                  <v-btn
                    color="green-darken-1"
                    variant="text"
                    @click="deleteMail()"
                  >
                    OK
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </v-window-item>
        <v-window-item value="tab3">
          <v-row justify="end" class="mt-1 mb-2 mr-2">
            <v-dialog v-model="resetDialog" persistent width="auto">
              <template v-slot:activator="{ props }">
                <v-btn color="primary" v-bind="props"
                  >LINE確認状況リセット</v-btn
                >
              </template>
              <v-card>
                <v-card-text>本当にリセットしますか？</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="green-darken-1"
                    variant="text"
                    @click="resetDialog = false"
                  >
                    キャンセル
                  </v-btn>
                  <v-btn
                    color="green-darken-1"
                    variant="text"
                    @click="reset_kidoku()"
                  >
                    OK
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-btn icon @click="update_kidoku" color="primary" class="ml-4">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-row>
          <table class="user-table">
            <thead>
              <tr>
                <th>名前</th>
                <th>確認状況</th>
                <th>確認日時</th>
                <th>最終アクティブ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in users" :key="user.uid">
                <td>{{ user.name }}</td>
                <td>
                  <span
                    :class="[
                      'status-badge',
                      user.safety_status === '確認済み'
                        ? 'is-safe'
                        : 'is-unknown',
                    ]"
                  >
                    {{ user.safety_status || "未確認" }}
                  </span>
                </td>
                <td>{{ user.safety_updated_at || "-" }}</td>
                <td>{{ user.updated_at }}</td>
              </tr>
            </tbody>
          </table>
        </v-window-item>
      </v-window>
    </v-card-text>
  </v-card>
  <v-card><v-card-text> </v-card-text></v-card>
</template>

<script>
import Export from "../export";
import store from "../store";
export default {
  name: "DisplayPosts",
  props: {
    msg: String,
  },
  mounted() {
    if (this.loginState == false) {
      this.$router.push("/");
    } else {
      this.getAllPosts();
      this.getAllMailAddress();
    }
  },
  data() {
    return {
      postTitle: "",
      postText: "",
      emergency: false,
      deliverMail: false,
      deleteDialog: false,
      deleteDialog2: false,
      tab: "tab1",
      postHeaders: [
        {
          title: "日時",
          value: "datetime",
        },
        {
          title: "タイトル",
          value: "title",
        },
        {
          title: "本文",
          value: "text",
        },
      ],
      mailHeaders: [
        {
          title: "氏名",
          value: "name",
        },
        {
          title: "メールアドレス",
          value: "mail",
        },
      ],
      selectedPosts: [],
      selectedMails: [],
      mailList: [],
      addName: "",
      addMail: "",
      users: [],
      resetDialog: false,
    };
  },
  computed: {
    posts: {
      get() {
        return store.state.posts;
      },
      set(value) {
        store.state.posts = value;
      },
    },
    loginState: {
      get() {
        return store.state.loginState;
      },
      set(value) {
        store.state.loginState = value;
      },
    },
    isLoading: {
      get() {
        return store.state.isLoading;
      },
      set(value) {
        store.state.isLoading = value;
      },
    },
    postList() {
      var list = [];
      for (var i = 0; i < this.posts.length; i++) {
        var item = this.posts[i];
        item.datetime = this.timestampToTime(this.posts[i].timestamp);
        list.push(item);
      }
      return list;
    },
  },
  methods: {
    async getAllPosts() {
      var getPosts = await Export.getAllPosts();
      this.posts = getPosts.data;
      this.posts = this.posts.sort(function (a, b) {
        return a.timestamp > b.timestamp ? -1 : 1; //オブジェクトの降順ソート
      });
    },
    async getAllMailAddress() {
      var getAllMailAddress = await Export.getAllMailAddress();
      this.mailList = getAllMailAddress.data;
    },
    async deletePosts() {
      this.isLoading = true;
      for await (let id of this.selectedPosts) {
        await Export.deletePost(id);
      }
      await this.getAllPosts();
      this.deleteDialog = false;
      this.isLoading = false;
    },
    async deleteMail() {
      this.isLoading = true;
      for await (let id of this.selectedMails) {
        await Export.deleteMail(id);
      }
      await this.getAllMailAddress();
      this.deleteDialog2 = false;
      this.isLoading = false;
    },
    timestampToTime(timestamp) {
      var d = new Date(Number(timestamp));
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hour = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      var min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      var sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      return (
        year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec
      );
    },
    makeShort(txt) {
      var st = txt.substr(0, 12);
      return st + "...";
    },
    showDetail(id) {
      this.detailPanel = true;
      this.detailIndex = id;
    },
    async post() {},
    async vacuum() {
      this.isLoading = true;
      await Export.vacuum();
      this.isLoading = false;
    },
    async mailList_add() {
      if (this.addMail == "") {
        alert("メールアドレスを入力してください。");
        return;
      }
      if (this.addName == "") {
        alert("名前を入力してください。");
        return;
      }
      if (this.addMail != "" && this.addName != "") {
        await Export.mailList_add(this.addName, this.addMail);
        this.addName = "";
        this.addMail = "";
        this.getAllMailAddress();
      }
    },
    async get_line_info() {
      this.isLoading = true;
      var get_line_info = await Export.get_line_info();
      this.users = get_line_info.data.users;
      this.isLoading = false;
    },
    async reset_kidoku() {
      this.resetDialog = false;
      this.isLoading = true;
      await Export.safety_reset();
      var get_line_info = await Export.get_line_info();
      this.users = get_line_info.data.users;
      this.isLoading = false;
    },
    async update_kidoku() {
      this.isLoading = true;
      var get_line_info = await Export.get_line_info();
      this.users = get_line_info.data.users;
      this.isLoading = false;
    },
  },
  watch: {
    tab() {
      if (this.tab == "tab3") {
        this.get_line_info();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.v-card-text {
  font-size: 1rem !important;
}
.v-card-subtitle {
  font-size: 0.9rem !important;
}
.itemList dt {
  font-size: 0.9rem !important;
  color: #7a7a7a;
}
.itemList dd {
  font-size: 1rem !important;
}
.sectionTitle {
  color: #44bd3f;
  text-align: center;
}
.user-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}
.user-table th,
.user-table td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
}
.status-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.85em;
  font-weight: bold;
}
.is-safe {
  background-color: #d4edda;
  color: #155724;
}
.is-unknown {
  background-color: #f8d7da;
  color: #721c24;
}
.user-table th {
  text-align: center;
  background-color: #e3ffe2;
}
</style>
